import ModalSelectGoalGear from "./ModalSelectGoalGear";
export default ModalSelectGoalGear;
